import { useState } from 'react';
import styled from 'styled-components';
import CardProjects from './cardProjects';
import VideoCard from './videoCardMore';
import {
  ContainerMarginSections,
  DisplayTitle,
  SectionLabel,
  ScriptAccent,
  Colors,
  fonts,
} from '../style/GlobalStyles';
import ManyOtherVideo from '../assets/videos/manyother.mp4';

const Head = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 3.5rem;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5rem;
`;

const MoreBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 2.5rem;
`;

const MoreTitle = styled.h3`
  font-family: ${fonts.display};
  text-transform: uppercase;
  font-size: clamp(2.4rem, 7vw, 5rem);
  color: ${Colors.ink};
  line-height: 0.95;
  margin: 0;

  span {
    color: ${Colors.lavender};
  }
`;

const Projets = ({ projects = [] }) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <ContainerMarginSections>
      <Head>
        <SectionLabel className="gsap-fade-up">Selected Work</SectionLabel>
        <DisplayTitle className="gsap-fade-up">Success stories</DisplayTitle>
      </Head>

      <List className="gsap-fade-up">
        {projects.map((p, i) => (
          <CardProjects
            key={p.id}
            id={p.id}
            nombre={p.nombre}
            tags={p.tags}
            video={p.video}
            desc={p.desc}
            category={p.category}
            open={openIndex === i}
            onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
          />
        ))}
      </List>

      <MoreBlock className="gsap-fade-up">
        <ScriptAccent>and there's more where that came from</ScriptAccent>
        <MoreTitle>
          And<br />
          many <span>others</span>
        </MoreTitle>
        <VideoCard url={ManyOtherVideo} />
      </MoreBlock>
    </ContainerMarginSections>
  );
};

export default Projets;
